function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExcel = function SvgExcel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M294.656 13.014a10.67 10.67 0 0 0-9.045-2.133l-277.333 64A10.67 10.67 0 0 0 0 85.377v362.667a10.67 10.67 0 0 0 9.045 10.539l277.333 42.667c5.823.895 11.269-3.099 12.164-8.921q.124-.804.124-1.617V21.377a10.66 10.66 0 0 0-4.01-8.363",
    style: {
      fill: "#4caf50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.334 458.71H288c-5.891 0-10.667-4.776-10.667-10.667s4.776-10.667 10.667-10.667h202.667V74.71H288c-5.891 0-10.667-4.776-10.667-10.667S282.109 53.377 288 53.377h213.333c5.891 0 10.667 4.776 10.667 10.667v384c0 5.891-4.775 10.666-10.666 10.666",
    style: {
      fill: "#4caf50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.667 352.044a10.67 10.67 0 0 1-9.045-5.013L86.955 176.364c-3.279-4.894-1.969-11.52 2.925-14.799s11.52-1.969 14.799 2.925q.193.288.367.588l106.667 170.667c3.11 5.003 1.576 11.58-3.427 14.691a10.7 10.7 0 0 1-5.619 1.608",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 352.044c-5.891-.012-10.657-4.797-10.645-10.688a10.67 10.67 0 0 1 1.621-5.632l106.667-170.667c2.954-5.097 9.481-6.834 14.577-3.88 5.097 2.954 6.834 9.481 3.88 14.577q-.174.3-.367.588L105.067 347.009A10.67 10.67 0 0 1 96 352.044",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.334 458.71c-5.891 0-10.667-4.776-10.667-10.667v-384c0-5.891 4.776-10.667 10.667-10.667s10.667 4.776 10.667 10.667v384c-.001 5.892-4.776 10.667-10.667 10.667",
    style: {
      fill: "#4caf50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.334 394.71H288c-5.891 0-10.667-4.776-10.667-10.667s4.776-10.667 10.667-10.667h213.333c5.891 0 10.667 4.776 10.667 10.667 0 5.892-4.775 10.667-10.666 10.667M501.334 330.71H288c-5.891 0-10.667-4.776-10.667-10.667s4.776-10.667 10.667-10.667h213.333c5.891 0 10.667 4.776 10.667 10.667 0 5.892-4.775 10.667-10.666 10.667M501.334 266.71H288c-5.891 0-10.667-4.776-10.667-10.667s4.776-10.667 10.667-10.667h213.333c5.891 0 10.667 4.776 10.667 10.667 0 5.892-4.775 10.667-10.666 10.667M501.334 202.71H288c-5.891 0-10.667-4.776-10.667-10.667s4.776-10.667 10.667-10.667h213.333c5.891 0 10.667 4.776 10.667 10.667s-4.775 10.667-10.666 10.667M501.334 138.71H288c-5.891 0-10.667-4.776-10.667-10.667s4.776-10.667 10.667-10.667h213.333c5.891 0 10.667 4.776 10.667 10.667 0 5.892-4.775 10.667-10.666 10.667",
    style: {
      fill: "#4caf50"
    }
  }));
};
export default SvgExcel;